var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.responsive == 'PC'|| _vm.responsive == 'pad' )?_c('pc-user-activity'):_vm._e(),(_vm.responsive == 'mobile')?_c('mobile-user-activity'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }